import { DetailWrapper } from "../../../../../features/ui"
import { PaymentTypeDetail } from "./paymentTypeDetail"

export const PaymentTypeDetailLoader = () => (
    <DetailWrapper>
        <PaymentTypeDetail />
    </DetailWrapper>
)
